<template>
    <div v-if="!!content">
        <h2 class="article-title">Felajánlások - <router-link to="/">Vissza</router-link></h2>
        <h4 class="mb-3">{{ content.category.name }} - {{ content.problem.description }}</h4>
        <div class="d-flex flex-wrap" style="margin: -0.5rem">
            <div class="offer-box border p-3 m-2" v-for="offer in content.offers" :key="offer.id">
                <div class="offer-title mb-3">
                    {{ offer.partner.name }}
                    <span></span>
                </div>

                <div class="offer-body">
                    <div class="row">
                        <div class="col-sm-4">A felajánlás</div>
                        <div class="col-sm-8 font-weight-bold">{{ offer.description }}</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">Cég neve</div>
                        <div class="col-sm-8 font-weight-bold">{{ offer.partner.name }}</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">E-mail cím</div>
                        <div class="col-sm-8 font-weight-bold">
                            <a v-if="!!offer.partner.email" :href="'mailto:' + offer.partner.email">{{ offer.partner.email }}</a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">Telefonszám</div>
                        <div class="col-sm-8 font-weight-bold">{{ offer.partner.phone }}</div>
                    </div>
                    <div class="row">
                        <div class="col-sm-4">Egyéb Infó</div>
                        <div class="col-sm-8 font-weight-bold">{{ offer.partner.optionalInfo }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';

    export default {
        props: {
            problemId: String
        },
        data() {
            return {
                content: null
            };
        },
        mounted() {
            axios
                .get(`https://admin2.ivsz.httpf.hu/api/problems/${this.$route.params.id}/offers`)
                .then(response => (this.content = response.data))
        }
    }
</script>

<style scoped>
    .offer-box {
        width: 500px;
    }
    .offer-title {
        text-transform: uppercase;
        text-decoration: none;
        color: #3b549e;
        font-weight: 700;
        font-size: 1em;
        line-height: 1.3em;
    }
    .offer-title span {
        display: block;
        height: 2px;
        width: 40px;
        margin-top: .5em;
        background: #3b549e;
    }
</style>